import ContentAddTagDlg from "@/views/content/contentTagsDlg/contentAddTagDlg/ContentAddTagDlg.vue";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import firebase from "firebase/app";
export default {
  name: "ContentTagsDlg",
  components: {
    ContentAddTagDlg,
    ConfirmDlg
  },
  data() {
    return {
      dialog: false,
      content: null,
      contentTags: [],
      loading: false
    }
  },
  computed: {
    contentAllTags() {
      return this.$store.state.contentCreatorModule.contentTags;
    },
    contentPages() {
      return this.$store.state.contentCreatorModule.content;
    },
  },
  methods: {
    open(content) {
      this.dialog = true;
      this.content = content;
      this.$store.dispatch("getContentTags");
      this.$store.dispatch("getCreatorContent");
      this.contentTags = this.contentAllTags.filter(x => this.content.tagsIds.includes(x.id));
    },
    close() {
      this.dialog = false;
    },
    saveTags() {
      this.$store.dispatch("saveContentTags", {
        content: this.content,
        tagsIds: this.contentTags.map(x => x.id)
      }).then(() => {
        this.$toast.open({
          type: "success",
          message: this.$t("ContentView.TagsSuccessfullyAdded")
        });
      }).catch((err) => {
        this.$toast.open({
          type: "error",
          message: this.$t("GeneralTranslations.UnhandledError")
        });
      })
    },
    addNewTag() {
      this.$refs.ContentAddTagDlg.open();
    },
    editTag(tag) {
      this.$refs.ContentAddTagDlg.open(tag)
    },
    async deleteTag(tag) {
      const records = await this.$store.dispatch("isContentTagInUse", tag.id)

      const message = records?.length > 0?
        this.$i18n.messages[this.$i18n.locale]['LifestyleProgramsSettings.TagWithDependencyQuestion'].replace('[records]', records.map(x=>x.name).join(', ')):
        this.$i18n.messages[this.$i18n.locale]['LifestyleProgramsSettings.DeleteTag'].replace('[name]', tag.name)

      this.$refs.confirmationModal.open(null, message, false)
        .then(async response => {
          if (response && response.agree) {
            this.$store.dispatch("deleteContentTag", tag.id);

            for(let i = 0; i < this.contentPages.length; i++) {
              const content = this.contentPages[i];

              if(content?.hasOwnProperty('tagsIds') && content?.tagsIds.includes(tag.id)) {
                await firebase
                  .firestore()
                  .collection("creatorContent")
                  .doc(content.id)
                  .update({
                    tagsIds: firebase.firestore.FieldValue.arrayRemove(tag.id)
                  })
              }
            }

            if(this.contentTags.find(x => x.id === tag.id)) {
              this.contentTags = this.contentTags.filter(x => x.id !== tag.id);
            }
          }
        });
    },
    selectTag(selectedTags) {
      const isOnlyObjects = selectedTags.every(element => {
        return typeof element === 'object' && element !== null && !Array.isArray(element);
      });

      if(isOnlyObjects) {
        this.contentTags = selectedTags.map((tag) => tag.trim().toLowerCase())
      } else {
        const newTag = selectedTags[selectedTags.length - 1];
        this.contentTags.pop();
        this.loading = true;
        setTimeout(async () => {
          const result = await this.$store.dispatch('addContentTags', { tagsNames: [newTag], entity: 'all' })

          if(result.existedTags && result.existedTags?.length > 0) {
            this.$refs.observer.setErrors({ Name: [`${result.existedTags.join(', ')} ${this.$t(`GeneralTranslations.Name${result.existedTags.length > 1 ? 's' : ''}AlreadyExists`)}`] });
          }

          if(result.addedTagIds?.length > 0) {
            const tag = this.contentAllTags.find(x => x.id === result.addedTagIds[0]);
            this.contentTags.push(tag)
          }

          this.loading = false;
        }, 100);
      }
    },
    removeTag(tagName) {
      this.contentTags = this.contentTags.filter(x => x !== tagName);
    },
    setContentTags() {
      this.contentTags.forEach(x => {
        const tag = this.contentAllTags.find(y => y.id === x.id);
        if(tag) {
          x.name = tag.name;
        }
      });
    }
  }
}